class SalesforceAccountConstant {
}
// thetrust        -   0011a000009XYETAA4
// meta            -   0011a00000MpvHxAAJ
SalesforceAccountConstant.META_ACCOUNT_ID = ['0011a00000MpvHxAAJ', '001Rp00000dg3PhIAI'];
SalesforceAccountConstant.EMAIL_EXCEPTION = ['0011a000009XYETAA4', '0011a00000MpvHxAAJ'];
export { SalesforceAccountConstant };
//# sourceMappingURL=salesforceAccountConstants.js.map